import { makeAutoObservable } from 'mobx';

import { AddressDTO } from "../DTOs/Address/AddressDTO";
import { ValidationResponse } from "../DTOs/ValidationResponse";
import { ajaxController } from "./AjaxController";

//#region POST Request models
type UpdateAddressRequest = {
  id: number
  description: string
  firstName: string
  surname: string
  companyName: string
  address1: string
  address2: string
  address3: string
  address4: string
  postCode: string
  country: string
  phoneDay: string
}

//#endregion

export class AddressAjaxController {
  private _ajaxController = ajaxController;
  private _stockistAddressEndpoint = "stockistAddress"

  getAddresses() {
    return this._ajaxController.get<AddressDTO[]>(`${this._stockistAddressEndpoint}`, {}, AddressDTO)
  }

  updateAddress(data: AddressDTO) {
    const model = {
      id: data.id,
      description: data.description || "Delivery Address",
      firstName: data.firstName,
      surname: data.surname,
      companyName: data.companyName,
      address1: data.address1,
      address2: data.address2,
      address3: data.address3,
      address4: data.address4,
      postCode: data.postCode,
      country: data.country,
      phoneDay: data.phoneDay
    };

    return this._ajaxController.postNoCast<UpdateAddressRequest, AddressDTO>(`${this._stockistAddressEndpoint}/save`, model)
  }

  addAddress(data: AddressDTO) {
    const model = {
      id: 0,
      description: data.description || "Delivery Address",
      firstName: data.firstName,
      surname: data.surname,
      companyName: data.companyName,
      address1: data.address1,
      address2: data.address2,
      address3: data.address3,
      address4: data.address4,
      postCode: data.postCode,
      country: data.country,
      phoneDay: data.phoneDay
    };

    return this._ajaxController.postNoCast<UpdateAddressRequest, AddressDTO>(`${this._stockistAddressEndpoint}/save`, model)
  }

  validateAddress(data: AddressDTO) {
    const model = {
      id: data.id,
      description: data.description ?? "",
      firstName: data.firstName,
      surname: data.surname,
      companyName: data.companyName,
      address1: data.address1,
      address2: data.address2,
      address3: data.address3,
      address4: data.address4,
      postCode: data.postCode,
      country: data.country,
      phoneDay: data.phoneDay
    };

    return this._ajaxController.post<UpdateAddressRequest, ValidationResponse>(`${this._stockistAddressEndpoint}/save/validate`, model, ValidationResponse)
  }

  deleteAddress(id: number) {
    return this._ajaxController.delete(`${this._stockistAddressEndpoint}/${id}`)
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const addressAjaxController = new AddressAjaxController();